import(/* webpackMode: "eager" */ "/codebuild/output/src1302824950/src/app/(auth)/login/page.js");
